export class User {
  
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  userId: string;
  role: string;

  constructor(data?: any) {
    if(data) {
      this.id = data.id;
      this.fullName = data.fullName || `${data.firstName} ${data.lastName}`;
      this.email = data.email;
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.userId = data.userId;
      this.role = data.role;
    }
  }
  
}